<template>
  <noscript>
    <iframe
      :src="'https://www.googletagmanager.com/ns.html?id=' + gtmId"
      height="0"
      width="0"
      style="display: none; visibility: hidden"
    ></iframe>
  </noscript>
</template>

<script>
export default {
  name: "GoogleTagManager",
  props: {
    gtmId: {
      type: String,
      required: true,
    },
  },
  mounted() {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${this.gtmId}`;
    document.head.appendChild(script);

    // Push GTM start event to dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "gtm.js",
      "gtm.start": new Date().getTime(),
    });
  },
};
</script>
